export default __webpack_public_path__ + "static/media/ico transfer.70c5c888.svg";